import { GenericEvent } from "types/Events";
import { getEnv } from "utils/env";
import { addEventToQueue } from "utils/event-batcher";
const env = getEnv();
env.dataLayer = env.dataLayer ? env.dataLayer : [];

export default (data: GenericEvent): void => {
  addEventToQueue(data, "GA");
};
